import { DashboardLayout } from "admin/components/layout/components/DashboardLayout";
import bg from "../assets/images/Image wrap outer.svg";
import { Tabs } from "antd";
import { BioInfo } from "../components/BioInfo";
import { CompanyInfo } from "../components/CompanyInfo";
import "../assets/style.css";
import { useState } from "react";
import { ReportTalent } from "../components/ReportTalent";
import { useParams } from "react-router-dom";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import avatar from "assets/images/default.webp";
import { useFetchRecruiterDetails } from "../hooks/useFetchRecruiterDetails";
import { JobList } from "../components/JobList";

export const AdminRecruiterDetails = () => {
  const params = useParams();
  const id = params.id;
  const { token } = useGetUserInfo();
  const [reportModaL, setReportModaL] = useState(false);
  const { data, isLoading } = useFetchRecruiterDetails({
    token,
    id: id as unknown as string,
  });

  return (
    <DashboardLayout container={false}>
      <ReportTalent
        open={reportModaL}
        handleClose={() => setReportModaL(false)}
      />
      <img
        src={data?.user?.cover_photo != null ? data?.user?.cover_photo : bg}
        alt="bg"
        className="w-full sm:w-auto"
      />
      <div className="Container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-5">
          <div className="flex items-center gap-3">
            <img
              src={data?.dp != null ? data.dp : avatar}
              alt="avatar"
              className="h-28 w-28 rounded-full object-cover object-top border-2 border-white -mt-7"
            />
            <div>
              <h3 className="font-semibold text-lg pb-1">
                {data?.first_name} {data?.last_name} {data?.middle_name}
              </h3>
              <h3 className="text-xs">{data?.user?.email}</h3>
            </div>
          </div>
          <div>
            <div className="flex gap-x-3 justify-start md:justify-end mt-3">
              {/*<AppButton
                label="Report"
                variant="transparent"
                handleClick={() => setReportModaL(true)}
              />
              <AppButton
                label="Send Invite"
                handleClick={() => setInviteModal(true)}
              />*/}
            </div>
          </div>
        </div>
        <Tabs defaultActiveKey="1" className="" size="large">
          <Tabs.TabPane tab="Bio Information" key="1" className="tabBg">
            <BioInfo isLoading={isLoading} data={data ? data : null} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Company Information" key="2" className="tabBg">
            <CompanyInfo isLoading={isLoading} data={data ? data : null} />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Jobs" key="3" className="tabBg">
            <JobList id={params.id} />
          </Tabs.TabPane>

          <Tabs.TabPane tab="Invite History" key="4" className="tabBg">
            <JobList id={params.id} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </DashboardLayout>
  );
};
